module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('editor', {
    attrs: {
      "id": "editor",
      "width": _vm.width,
      "height": _vm.height,
      "lang": _vm.lang,
      "theme": "monokai"
    },
    on: {
      "init": function($event) {
        return _vm.editorInit();
      }
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f275797","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextEditor.vue
// module id = 588
// module chunks = 2